import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { ArrayUtil } from '@aperza/util';
import CustomPageDetailDescription from './CustomPageDetailDescription';
import CustomPageDetailNavigation from './CustomPageDetailNavigation';
import CustomPageDetailContent from './detail/CustomPageDetailContent';
import CustomPageTopCarousel from './detail/CustomPageTopCarousel';

const CustomPageDetail = (props) => {

  let {
    customPageCache,
  } = props;

  return (
    <>
      {ArrayUtil.isNotEmpty(customPageCache.pageBlocks) && customPageCache.pageBlocks[0].pageBlockLayoutType.pageBlockLayoutTypeCode == 'CAROUSEL_SLIDER_LAYOUT' && 
        <CustomPageTopCarousel pageBlock={customPageCache.pageBlocks[0]} key={customPageCache.pageBlocks[0].pageBlockId} pageTypeId={customPageCache.pageTypeId}/>
      }
      <div className="m_contentWrap">
      {customPageCache.navigationType != 'HIDE_NAVIGATION' && ArrayUtil.isNotEmpty(customPageCache.pageBlocks) &&
      <CustomPageDetailNavigation pageBlocks={customPageCache.pageBlocks.slice( customPageCache.pageBlocks[0].pageBlockLayoutType.pageBlockLayoutTypeCode == 'CAROUSEL_SLIDER_LAYOUT' ? 1 : 0)}/>
      }
      {ArrayUtil.isNotEmpty(customPageCache.pageBlocks) &&
      <CustomPageDetailContent companyContractDisplayId={customPageCache.companyContractDisplayId}
                               pageBlocks={customPageCache.pageBlocks}/>
      }
      </div>
    </>
  );
};

CustomPageDetail.fragments = {
  customPageCache: gql`
      fragment CustomPageDetail_customPageCache on CustomPageCacheResponseSchemaType {
          companyContractDisplayId
          pageDescriptionHtml
          navigationType
          pageBlocks {
              pageBlockId
              pageBlockTitle
              ...CustomPageDetailContent_pageBlocks
          }
      }
      ${CustomPageDetailContent.fragments.pageBlocks}
  `,
};
CustomPageDetail.propTypes = {
  customPageCache: PropTypes.object.isRequired,
};

export default CustomPageDetail;
